
const initialState = {
    userStatsResponse: null,
    userDetails: null,
    organizationListByUserResponse: null,
    assignedorganizationListByUserResponse: null,
    inviteUserResponse: null,
    editUserResponse: null,
    userSessionById: null,
    deleteUserResponse: null,
    updateUserStatusSingleResponse: null,
    invitedUsersList: null,
    deleteUserInvite: null,
    resendInvite: null,
    editInviteuser: null
}

export default function usersReducers(state=initialState, action) {
    switch(action.type) {
        case 'USER_STATS_SUCCESS':
            return {
                ...state,
                userStatsResponse: action.payload
            }
        case 'USER_DETAILS_SUCCESS' :
            return {
                ...state,
                userDetails: action.payload
            }
        case 'RESET_USER_DETAILS_RESPONSE':
            return {
                ...state,
                userDetails: null
            }
        case 'ORGANIZATION_LIST_BY_USER_SUCCESS' :
            return {
                ...state,
                organizationListByUserResponse: action.payload
            }
        case 'RESET_ORGANIZATION_LIST_BY_USER_SUCCESS' :
            return {
                ...state,
                organizationListByUserResponse: null
            }
        case 'ASSIGNED_ORGANIZATION_LIST_BY_USER_SUCCESS' :
            return {
                ...state,
                assignedorganizationListByUserResponse: action.payload
            }
        case 'INVITE_USER_SINGLE_SUCCESS' :
            return {
                ...state,
                inviteUserResponse: action.payload
            }
        case 'RESET_INVITE_USER_RESPONSE' :
            return {
                ...state,
                inviteUserResponse: null
            }
        case 'EDIT_USER_SUCCESS' :
            return {
                ...state,
                editUserResponse: action.payload
            }
        case 'RESET_EDIT_USER_RESPONSE' :
            return {
                ...state,
                editUserResponse: null
            }
        case 'GET_USER_SESSION_BY_ID_SUCCESS':
            return {
                ...state,
                userSessionById: action.payload
            }
        case 'DELETE_USER_ID_SUCCESS':
            return {
                ...state,
                deleteUserResponse: action.payload
            }
        case 'RESET_DELETE_USER_ID':
            return {
                ...state,
                deleteUserResponse: null
            }
        case 'UPDATE_USER_STATUS_SINGLE_SUCCESS': 
            return {
                ...state,
                updateUserStatusSingleResponse: action.payload
            }
        case 'RESET_UPDATE_USER_STATUS_RESPONSE':
            return {
                ...state,
                updateUserStatusSingleResponse: null
            }
        case 'INVITED_USERS_LIST_SUCCESS':
            return {
                ...state,
                invitedUsersList: action.payload
            }
        case 'RESET_INVITED_USERS_LIST':
            return {
                ...state,
                invitedUsersList: null
            }
        case 'DELETE_INVITED_SUCCESS':
            return {
                ...state,
                deleteUserInvite: action.payload
            }
        case 'RESET_DELETE_INVITED_USERS_SUCCESS':
            return {
                ...state,
                deleteUserInvite: null
            }
        case 'RESEND_INVITE_SUCCESS':
            return {
                ...state,
                resendInvite: action.payload
            }
        case 'RESET_RESEND_INVITED_USER':
            return {
                ...state,
                resendInvite: null
            }
        case 'EDIT_INVITE_SUCCESS':
            return {
                ...state,
                editInviteuser: action.payload
            }
        case 'RESET_EDIT_INVITED_USER':
            return {
                ...state,
                editInviteuser: null
            }
        default:
            return state;
    }
}